
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.75 26.5H24V6.807l-.63-.449A12.66 12.66 0 0 0 15.998 4 12.66 12.66 0 0 0 8.63 6.355l-.63.449V26.5H6.25a.25.25 0 0 0-.25.25v1a.25.25 0 0 0 .25.25h19.5a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25ZM22.5 13h-5.75V5.529c2.07.14 4.06.85 5.75 2.052V13Zm-7.25-7.471V13H9.5V7.578a11.219 11.219 0 0 1 5.75-2.05ZM9.5 26.5v-12h5.75v12H9.5Zm7.25 0v-12h5.75v12h-5.75Z"}})])
          )
        }
      }
    